
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5574',
  depVersions: {
  "data-privacy-request-ui": "static-1.5574",
  "data-fetching-client": "static-1.9715",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8066",
  "hub-http-shared-msw-handlers": "static-1.10080",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11523",
  "I18n": "static-7.1633",
  "jasmine-runner": "static-1.6514",
  "privacy-center-public-service-types": "static-1.4837",
  "quartz": "static-1.7092",
  "react-dlb": "static-1.80",
  "ui-components-test-utils": "static-1.5660",
  "UIComponents": "static-3.8469",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.87",
  "foundations-assets": "static-1.4920",
  "foundations-components": "static-1.8023",
  "foundations-components-test-utils": "static-1.5506",
  "foundations-theming": "static-1.4473",
  "hub-http": "static-1.6273",
  "quartz-config": "static-1.870",
  "quartz-core": "static-1.6311",
  "quartz-routing": "static-1.522",
  "quick-fetch": "static-1.3958",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-rhumb": "static-1.16728",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11201",
  "usage-tracker": "static-1.7400",
  "usage-tracker-anonymous": "static-1.5817",
  "usage-tracker-core": "static-1.7250",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3439",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3369",
  "quartz-webpack": "static-1.3316",
  "bend-plugin-quartz-routing": "static-1.170",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "HeadJS": "static-2.765",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3177",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "ts-schema": "static-1.4120",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "react-utils": "static-2.5384",
  "StyleGuideUI": "static-3.488",
  "jasmine": "static-4.4375",
  "rpc-client-utils": "static-1.4703",
  "HubStyle": "static-2.11830",
  "ui-addon-draggable": "static-3.4813",
  "cssUtils": "static-1.804",
  "hs-story-utils": "static-1.9473",
  "icons": "static-2.650",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1165",
  "bend-plugin-foundations-components": "static-1.4292",
  "floating-ui": "static-1.57",
  "foundations-theming-specialty": "static-1.2189",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2071",
  "ui-fonts": "static-1.785",
  "foundations-components-legacy": "static-1.1048",
  "bend-plugin-foundations-theming": "static-1.2956",
  "foundations-theming-base": "static-1.3458",
  "stylex": "static-1.34",
  "hs-locale-management": "static-1.121",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4691",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.767",
  "quartz-head": "static-1.757",
  "quartz-i18n": "static-1.767",
  "quartz-test": "static-1.767",
  "quartz-tracking": "static-1.471",
  "usage-tracker-container": "static-1.7390",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3227",
  "bend-plugin-chirp-manifest": "static-1.113",
  "chirp-fetch": "static-1.1938",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.72",
  "sassPrefix": "static-1.157",
  "hubspotter-http-shared-msw-handlers": "static-1.10078",
  "usage-tracker-session-replay": "static-1.5086",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5574",
  "data-fetching-client": "/data-fetching-client/static-1.9715",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8066",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10080",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11523",
  "I18n": "/I18n/static-7.1633",
  "jasmine-runner": "/jasmine-runner/static-1.6514",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4837",
  "quartz": "/quartz/static-1.7092",
  "react-dlb": "/react-dlb/static-1.80",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5660",
  "UIComponents": "/UIComponents/static-3.8469",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "foundations-assets": "/foundations-assets/static-1.4920",
  "foundations-components": "/foundations-components/static-1.8023",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5506",
  "foundations-theming": "/foundations-theming/static-1.4473",
  "hub-http": "/hub-http/static-1.6273",
  "quartz-config": "/quartz-config/static-1.870",
  "quartz-core": "/quartz-core/static-1.6311",
  "quartz-routing": "/quartz-routing/static-1.522",
  "quick-fetch": "/quick-fetch/static-1.3958",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-rhumb": "/react-rhumb/static-1.16728",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11201",
  "usage-tracker": "/usage-tracker/static-1.7400",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5817",
  "usage-tracker-core": "/usage-tracker-core/static-1.7250",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3439",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3369",
  "quartz-webpack": "/quartz-webpack/static-1.3316",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.170",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "HeadJS": "/HeadJS/static-2.765",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3177",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "ts-schema": "/ts-schema/static-1.4120",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "react-utils": "/react-utils/static-2.5384",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "jasmine": "/jasmine/static-4.4375",
  "rpc-client-utils": "/rpc-client-utils/static-1.4703",
  "HubStyle": "/HubStyle/static-2.11830",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4813",
  "cssUtils": "/cssUtils/static-1.804",
  "hs-story-utils": "/hs-story-utils/static-1.9473",
  "icons": "/icons/static-2.650",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1165",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4292",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2189",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2071",
  "ui-fonts": "/ui-fonts/static-1.785",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1048",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2956",
  "foundations-theming-base": "/foundations-theming-base/static-1.3458",
  "stylex": "/stylex/static-1.34",
  "hs-locale-management": "/hs-locale-management/static-1.121",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4691",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.767",
  "quartz-head": "/quartz-head/static-1.757",
  "quartz-i18n": "/quartz-i18n/static-1.767",
  "quartz-test": "/quartz-test/static-1.767",
  "quartz-tracking": "/quartz-tracking/static-1.471",
  "usage-tracker-container": "/usage-tracker-container/static-1.7390",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.113",
  "chirp-fetch": "/chirp-fetch/static-1.1938",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.72",
  "sassPrefix": "/sassPrefix/static-1.157",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10078",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5086",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
